import { render, staticRenderFns } from "./admin_users_roles.vue?vue&type=template&id=6064f356&scoped=true"
import script from "./admin_users_roles.vue?vue&type=script&lang=js"
export * from "./admin_users_roles.vue?vue&type=script&lang=js"
import style0 from "./admin_users_roles.vue?vue&type=style&index=0&id=6064f356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6064f356",
  null
  
)

export default component.exports